const states = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];
export function StateSelect({ value, onChange }: { value: string; onChange: (e: { target: { value: string } }) => void }) {
  return <select value={value} onChange={onChange} autoComplete="address-level1">
    <option value="">Select state or territory</option>
    {value && !states.includes(value) && <option value={value}>{value}</option>}
    {states.map(state => <option key={state} value={state}>{state}</option>)}
  </select>;
}
